module.exports = __webpack_public_path__ + "img/desc_bottom_tf3661.e5e734cd.png";